import { classes } from "lib/actions/util";
import TickSvg from "components/icons/deprecated/tick.svg";

export default function InputCheckbox<VType extends string | number>(p: {
  isChecked: boolean;
  name?: string;
  value?: VType;
  onChange?(): void;
}) {
  return (
    // Relative so the sr-only input stays inside its row in a scrolling list,
    // otherwise focusing it scrolls an overflow-hidden ancestor out of view
    <span
      className={classes(
        "relative flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded border",
        "focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-1",
        p.isChecked
          ? "border-primary-500 bg-primary-500 group-hover/checkbox-item:border-primary-600 group-hover/checkbox-item:bg-primary-600"
          : "border-secondary-500  group-hover/checkbox-item:border-primary-600",
      )}
    >
      <input
        type="checkbox"
        name={p.name}
        value={p.value}
        checked={p.isChecked}
        className="sr-only"
        onChange={() => p.onChange?.()}
      />
      {p.isChecked && <TickSvg className="h-full w-full text-white" />}
    </span>
  );
}
